export const oddsTypeSettingsName = 'asianViewOddsType';
